import type { CSSProperties, ReactNode } from "react";
import { C, card, sectionTitle } from "../theme";

/** Dark panel with an uppercase heading; `flush` removes side padding so tables run edge to edge. */
export const Card = ({
  title,
  aside,
  children,
  flush,
  style,
}: {
  title?: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
  flush?: boolean;
  style?: CSSProperties;
}) => (
  <section
    style={{
      ...card,
      padding: flush ? "18px 0 8px" : "20px 24px",
      display: "flex",
      flexDirection: "column",
      gap: flush ? 10 : 14,
      ...style,
    }}
  >
    {(title || aside) && (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 10,
          padding: flush ? "0 20px" : 0,
        }}
      >
        {title && <h3 style={sectionTitle}>{title}</h3>}
        {aside && (
          <div style={{ fontSize: 12, color: C.muted }}>{aside}</div>
        )}
      </div>
    )}
    {children}
  </section>
);

/** Two-column label/value grid used in the Resumen cards. */
export const InfoGrid = ({
  items,
}: {
  items: { label: string; value: ReactNode; valueStyle?: CSSProperties }[];
}) => (
  <dl
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: "10px 16px",
      fontSize: 13,
      margin: 0,
    }}
  >
    {items.map((it) => (
      <div key={it.label} style={{ display: "contents" }}>
        <dt style={{ color: C.muted }}>{it.label}</dt>
        <dd style={{ margin: 0, textAlign: "right", color: C.white, ...it.valueStyle }}>
          {it.value}
        </dd>
      </div>
    ))}
  </dl>
);
